import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

const journals = () => import('./journals-pages');
const accounts = () => import('./accounts-pages');
const reports = () => import('./reports-pages');
const vat = () => import('./vat-pages');
const close = () => import('./close-pages');
const planning = () => import('./planning-pages'); // P3 finance
const assets = () => import('./assets-pages'); // P3 finance

// G1: accounting ledger (Xero / QuickBooks Online UK). Owned by the accounting module.
// G5–G7: reports, VAT / Making Tax Digital, year end and opening balances.
export const routes: RouteObject[] = [
  {
    path: 'accounting',
    lazy: page(journals, (m) => m.AccountingLayout),
    children: [
      { index: true, lazy: page(journals, (m) => m.JournalsPage) },
      { path: 'repeating', lazy: page(planning, (m) => m.RepeatingJournalsPage) },
      { path: 'budgets', lazy: page(planning, (m) => m.BudgetsPage) },
      { path: 'assets', lazy: page(assets, (m) => m.AssetsPage) },
      { path: 'accounts', lazy: page(accounts, (m) => m.AccountsPage) },
      { path: 'reports', lazy: page(reports, (m) => m.ReportsPage) },
      { path: 'vat', lazy: page(vat, (m) => m.VatPage) },
      { path: 'year-end', lazy: page(close, (m) => m.YearEndPage) },
      { path: 'skipped', lazy: page(() => import('./skipped-page'), (m) => m.SkippedDocumentsPage) }, // Track 4
      { path: 'opening-balances', lazy: page(close, (m) => m.OpeningBalancesPage) },
      { path: 'settings', lazy: page(() => import('./settings-page'), (m) => m.AccountingSettingsPage) },
    ],
  },
  // Journals, account transactions, reports and VAT returns open full width, outside the tabbed frame.
  { path: 'accounting/journals/new', lazy: page(journals, (m) => m.NewJournalPage) },
  { path: 'accounting/journals/:id', lazy: page(journals, (m) => m.JournalDetailPage) },
  { path: 'accounting/repeating/:id', lazy: page(planning, (m) => m.RepeatingJournalPage) },
  { path: 'accounting/budgets/:id', lazy: page(planning, (m) => m.BudgetDetailPage) },
  { path: 'accounting/assets/:id', lazy: page(assets, (m) => m.AssetPage) },
  { path: 'accounting/accounts/:id', lazy: page(accounts, (m) => m.AccountTransactionsPage) },
  { path: 'accounting/reports/vat/lines', lazy: page(reports, (m) => m.VatLinesPage) },
  { path: 'accounting/reports/:key', lazy: page(reports, (m) => m.LedgerReportPage) },
  { path: 'accounting/vat/hmrc-callback', lazy: page(vat, (m) => m.HmrcCallbackPage) },
  { path: 'accounting/vat/returns/:periodKey/review', lazy: page(vat, (m) => m.VatReturnReviewPage) },
  { path: 'accounting/vat/returns/:id', lazy: page(vat, (m) => m.VatReturnDetailPage) },
];

export const orgRoutes: RouteObject[] = [];
